import React from "react";
import Radium from "radium";
import { Dropdown } from "semantic-ui-react";
import moment from "moment";
import CustomSelect from "components/Form/Select";

const styles = {
	select: {
		width: "100%",
		height: 38,
		border: "1px solid rgba(34,36,38,.15)",
		transition: "box-shadow .1s ease,border-color .1s ease",
		background: "transparent",
		fontSize: "0.9em",
		":focus": {
			border: "1px solid #85b7d9",
			outline: "none",
		},
		":active": {
			outline: "none",
			border: "1px solid #85b7d9",
		},
	},
	customlabel: {
		fontSize: "1em",
		fontWeight: 600,
		marginBottom: 10,
		marginTop: 5,
		marginLeft: 2,
		width: "90%",
	},
	inputStyle: {
		width: "100%",
	},
	inputContainer: {
		width: "100%",
		display: "flex",
		alignItems: "center",
	},
	records: {
		position: "absolute",
		right: 0,
	},
	crossRequired: {
		color: "#c5190e",
		fontSize: "1em",
		position: "relative",
		bottom: 4,
		left: 4,
	},
};

const Records = ({ records, onClick, disabled }) => (
	<Dropdown
		closeOnEscape
		closeOnChange
		icon="file alternate outline"
		direction="right"
		style={styles.records}
		className="largegreenIcon"
		disabled={disabled}
	>
		<Dropdown.Menu direction="left">
			<Dropdown.Header icon="folder outline" content="Antécédants" />
			<Dropdown.Divider />
			{records.map((r, i) => (
				<Dropdown.Item
					key={r.label + " " + r.value + i}
					description={moment(r.created_at).format(`${process.env.REACT_APP_DATE_DISPLAY_FORMAT}, ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`)}
					onClick={(e) => {
						if (e !== undefined) e.preventDefault();
						onClick(r);
					}}
					text={String(r.label)}
				/>
			))}
		</Dropdown.Menu>
	</Dropdown>
);

const Select = ({
	field: { name, value, onChange, onBlur },
	form: { errors, touched, setFieldValue },
	id,
	label,
	className,
	options,
	records,
	disabled,
	...props
}) => {
	const customOnBlur = (e) => {
		onBlur(e);
		if (props.prevalidfolders) props.prevalidfolders();
	};
	//Prevent error
	delete props["prevalidfolders"];

	return (
		<div>
			<div style={styles.customlabel}>
				{props.customlabel}
				{props.required && <span style={styles.crossRequired}>*</span>}
				{records.length > 0 && (
					<Records
						records={records}
						onClick={(r) => {
							if (r.from_free_input) {
								props.setFieldValue(name, "freeInput");
								props.setFieldValue(name + "freeInput", r.value);
							} else {
								props.setFieldValue(name, r.value[0]);
							}
						}}
						disabled={disabled}
					/>
				)}
			</div>

			<CustomSelect
				field={{
					name,
					value,
					onBlur: (e) => customOnBlur(e),
					onChange: { onChange },
				}}
				form={{
					errors,
					touched,
					setFieldValue,
				}}
				label=""
				style={styles.select}
				className={errors[name] ? "selectOnError" : ""}
				options={options.map((op) => ({
					value: op?.value,
					label: op?.label,
				}))}
				disabled={disabled}
			/>
		</div>
	);
};

export default Radium(Select);
